import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../Theme';

const SpecTable = styled('table')`
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
`;

const SpecRow = styled('tr')`
  border-bottom: 1px solid #e0e0e0;

  &:last-child {
    border-bottom: none;
  }

  &:nth-child(even) {
    background-color: #f9f9f9;
  }
`;

const SpecLabel = styled('td')`
  padding: 10px 16px;
  font-weight: 600;
  width: 40%;
  border-right: 1px solid #e0e0e0;
  font-size: 14px;
  white-space: nowrap;
`;

const SpecValueWrapper = styled('td')`
  padding: 10px 16px;
  font-size: 14px;
`;

const valueOfTypeField = {
  STRING: 'stringValue',
  HTML: 'htmlValue',
  LIST: 'listValues',
  MULTI_LEVEL_LIST: 'items',
  BOOL: 'boolValue'
};

 export const includeFieldsWithKey = [
    'Product_Type',
    'ProductSubtype',
    'Brand',
    'Material',
    'Buckle',
    'CountryOfOrigin',
    'DetachableNoseband',
    'Foldable',
    'EarProtectionBars',
    'FrontClosure',
    'Function',
    'HoleToAttachLead',
    'LeatherChinStrap',
    'LegTies',
    'LinedHeadPieceAndNoseband',
    'LinerLoops',
    'Lining',
    'MVTBreathability',
    'Neck',
    'OpeningForHarness',
    'PatentedSafetyFastening',
    'PcsPerPack',
    'PhonePocket',
    'ReflectiveDetails',
    'Reins',
    'RibbingAtBottomHemAndWrists',
    'RidingVents',
    'SaddleAttachmentStraps',
    'SafteyStandards',
    'ShoulderGusset',
    'SizeAdjustment',
    'SoftPeakForReducedRiskOfInjury',
    'Surcingles',
    'Three-pointFastening',
    'Tail',
    'TreatedWithRudolfBionicFinishEco',
    'Two-wayFrontZip',
    'Waist',
    'Warranty',
    'Washing',
    'WaterColumn',
    'Weight',
    'VelcroFastening',
    'Ventilation',
    'Batteries',
    'Electronics',
    'Sustainable',
    // **** HÄR BÖRJAR GAMLA MALLDELAR SOM FORTFARANDE ANVÄNDS ****
    'ProductMaterial',
    'ProductProperties'
  ];

  const checkIfFieldHasValue = field => {
    if (field?.type === 'BOOL') {
      return true;
    }
    return !!field?.[valueOfTypeField?.[field?.type]];
  };


export const productHasCustomFields = product => {
  return product?.customFields?.some(field => {
    return includeFieldsWithKey?.includes(field?.key) && checkIfFieldHasValue(field);
  });
};

export const ProductCustomFieldsSpec = ({ product}) => {
  // In admin this is the ID
 


  const customFields = product?.customFields;
  
  if (!customFields || customFields.length === 0) {
    return null;
  }


  return (
    <SpecTable>
      <tbody>
        {customFields?.map(field => {
          if (
            includeFieldsWithKey?.includes(field?.key) &&
            checkIfFieldHasValue(field)
          ) {
            return (
              <SpecRow key={field?.key}>
                <SpecLabel>{field?.title}</SpecLabel>
                <SpecValue field={field} />
              </SpecRow>
            );
          } else {
            return null;
          }
        })}
      </tbody>
    </SpecTable>
  );
};

const SpecValue = ({ field }) => {
  switch (field?.type) {
    case 'STRING':
      return <SpecValueWrapper>{field?.stringValue}</SpecValueWrapper>;
    case 'HTML':
      return (
        <SpecValueWrapper>
          <div dangerouslySetInnerHTML={{ __html: field?.htmlValue }}></div>
        </SpecValueWrapper>
      );
    case 'LIST':
      return (
        <SpecValueWrapper>
          {field?.listValues?.map(value => value?.label).join(', ')}
        </SpecValueWrapper>
      );
    case 'MULTI_LEVEL_LIST':
      return (
        <SpecValueWrapper>
          {field?.items?.map(item => {
            return <p>{`${item?.title} - ${item?.value}`}</p>;
          })}
        </SpecValueWrapper>
      );
    case 'BOOL':
      return (
        <SpecValueWrapper>
          <BoolIcon value={field?.boolValue} />
        </SpecValueWrapper>
      );

    default:
      return null;
  }
};

const BoolIconWrapper = styled('div')`
  width: 24px;
  height: 24px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BoolIcon = ({ value }) => {
  if (value) {
    return (
      <BoolIconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
          <path
            fill={theme.colors.green}
            d="M320 576C178.6 576 64 461.4 64 320S178.6 64 320 64s256 114.6 256 256-114.6 256-256 256m0-480C196.3 96 96 196.3 96 320s100.3 224 224 224 224-100.3 224-224S443.7 96 320 96m83.1 134.6c5.2-7.1 15.2-8.7 22.3-3.5s8.7 15.2 3.5 22.3l-128 176c-2.8 3.8-7 6.2-11.7 6.5s-9.3-1.3-12.6-4.6l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l50.7 50.7 117-160.8z"
          />
        </svg>
      </BoolIconWrapper>
    );
  } else {
    return (
      <BoolIconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
          <path
            fill={theme.colors.red}
            d="M320 96c123.7 0 224 100.3 224 224S443.7 544 320 544 96 443.7 96 320 196.3 96 320 96m0 480c141.4 0 256-114.6 256-256S461.4 64 320 64 64 178.6 64 320s114.6 256 256 256m-91.3-347.3c-6.2 6.2-6.2 16.4 0 22.6l68.7 68.7-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l68.7-68.7 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L342.6 320l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 297.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0"
          />
        </svg>
      </BoolIconWrapper>
    );
  }
};
